import { render, staticRenderFns } from "./detection.vue?vue&type=template&id=c634e1e4&scoped=true"
import script from "./detection.vue?vue&type=script&lang=js"
export * from "./detection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c634e1e4",
  null
  
)

export default component.exports